import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-tab-brief',
  templateUrl: './profile-tab-brief.component.html',
  styleUrls: ['./profile-tab-brief.component.scss']
})
export class ProfileTabBriefComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
